import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import EntityId = com.eidu.entity.EntityId

type ListVersionsParameters = { id: EntityId }

export type VersionRecord = {
  entityId: string
  versionId: string
  logId: string
  snapshotResourceKey: string
  payloadKey: string | null
  dependencyCount: number
  createdAt: number
  createdBy: string
}

const listVersions = async ({ id }: ListVersionsParameters): Promise<VersionRecord[]> => {
  const response = await fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${id.toString()}/versions`,
    {
      method: 'GET',
    }
  )
  if (response.status !== 200) throw Error(`Unexpected response code ${response.status} from listVersions endpoint`)
  return (await response.json()) as VersionRecord[]
}

export default listVersions
